exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{font-family:Microsoft YaHei,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;height:100%}body,html{font-size:14px;height:100%}*{padding:0;margin:0}input{border:none;outline:none;-webkit-appearance:none}ol,ul{list-style:none}.f_left{float:left}.f_right{float:right}.clearfix:after,.clearfix:before{content:\"\";height:0;line-height:0;display:block;visibility:hidden;clear:both}", ""]);

// exports
